import type { Point } from "web_myplann/Chat/Types/pinchZoom";

export const midpointOf = (a: Point, b: Point): Point => ({
	x: (a.x + b.x) / 2,
	y: (a.y + b.y) / 2,
});
